/* Fight Trade · Bangkok Light · stock scales: "Florida stock" above "Bangkok stock" (approved 2026-10-23).
   Markup: snippets/ft-stock-scales.liquid, printed by snippets/product-form.liquid only for qualifying products;
   this file is loaded (defer) only together with that markup. Styles: fight-trade-a.css section 26.

   Yuva 13.0.8 stays in charge of the variant. Its Weight/Size and Ship From inputs (name="option-N" inside
   <variant-selects id="variantSelects-<section>">) stay in the DOM, visually hidden and inert. A pick on a scale
   sets BOTH of them (plus the colour, which the scales follow) and then dispatches ONE bubbling "change" on the
   last input set, so VariantSelects -> ProductInfo resolve one combination only and update the price, ?variant=,
   add to cart / sold out, sticky bar, gallery and the weight guide (:has on the weight fieldset).
   After every Yuva update (scale, colour, sticky bar) the scales are swapped for the copy rendered in the same
   section response, so prices and stock follow the selected colour; focus stays on the picked cell.
   Florida priority on load: with no ?variant= the server checks the first available Florida variant (else
   Bangkok) and sets data-ft-sync="1"; the snippet's inline script already set Yuva's inputs and the price, and
   init() hands the variant to Yuva. Delegated listeners; a second copy of this file does nothing. */
(function () {
  'use strict';
  if (window.ftStockScales) return;
  window.ftStockScales = true;

  var ROOT = '.ft-stock';
  var INPUT = 'ft-stock__input';

  function attr(el, name) {
    return el ? el.getAttribute(name) : null;
  }

  /* Yuva's picker of the same section (the sticky bar repeats the id, so look next to the scales first) */
  function variantSelects(root) {
    var id = 'variantSelects-' + attr(root, 'data-section');
    var list = root.parentNode ? root.parentNode.querySelectorAll('variant-selects') : [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i];
    }
    return document.getElementById(id);
  }

  /* checks Yuva's input of option N with this value; returns { el, changed } or null */
  function setYuva(vs, pos, value) {
    if (!vs || !pos || value === null) return null;
    var els = vs.querySelectorAll('[name="option-' + pos + '"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.tagName === 'SELECT') {
        var hit = null;
        for (var k = 0; k < el.options.length; k++) {
          if (el.options[k].value === value) hit = el.options[k];
        }
        if (!hit) return null;
        var was = el.value;
        el.value = value;
        /* Yuva reads "select option[selected]" (the attribute) */
        for (k = 0; k < el.options.length; k++) {
          if (el.options[k] === hit) el.options[k].setAttribute('selected', '');
          else el.options[k].removeAttribute('selected');
        }
        return { el: el, changed: was !== value };
      }
      if (el.value === value) {
        var on = el.checked;
        el.checked = true;
        return { el: el, changed: !on };
      }
    }
    return null;
  }

  function setLegend(root, radio) {
    var out = root.querySelector('.ft-stock__value');
    if (out) out.textContent = radio ? attr(radio, 'data-size') + ' \u00b7 ' + attr(radio, 'data-where') : '';
  }

  /* hand the picked variant to Yuva: colour, size and ship first, then ONE change event */
  function handOver(root, radio, force) {
    var vs = variantSelects(root);
    if (!vs || !radio) return;
    var color = setYuva(vs, attr(root, 'data-color-option'), attr(root, 'data-color'));
    var size = setYuva(vs, attr(root, 'data-size-option'), attr(radio, 'data-size'));
    var ship = setYuva(vs, attr(root, 'data-ship-option'), attr(radio, 'data-ship'));
    setLegend(root, radio);
    if (!size || !ship) return;
    if (!force && !size.changed && !ship.changed && !(color && color.changed)) return;
    /* the form posts the right variant even before Yuva's response arrives */
    var form = document.getElementById('product-form-' + attr(root, 'data-section'));
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    if (idInput) idInput.value = radio.value;
    ship.el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* check the scale cell of this variant (none if the variant is not on the scales) */
  function check(root, variantId) {
    var hit = null;
    var radios = root.querySelectorAll('.' + INPUT);
    for (var i = 0; i < radios.length; i++) {
      var on = variantId !== null && variantId !== undefined && String(radios[i].value) === String(variantId);
      radios[i].checked = on;
      if (on) hit = radios[i];
    }
    setLegend(root, hit);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains(INPUT) || !t.checked || t.disabled) return;
    var root = t.closest(ROOT);
    if (root) handOver(root, t, false);
  });

  /* size chart link (Yuva binds its own links once, on load; this also covers re-rendered scales) */
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('.ft-stock__chart-link') : null;
    var modal = link ? document.getElementById('sizeChartModel') : null;
    if (!modal) return;
    e.preventDefault();
    document.body.classList.add('sizeChartOpen');
    var close = modal.querySelector('#sizeChartClose');
    if (close) close.focus();
  });

  /* Yuva's pub/sub (assets/common.js): published after it re-rendered the section for the new variant */
  function onVariantChange(payload) {
    var d = payload && payload.data;
    if (!d || !d.sectionId) return;
    var root = document.getElementById('FtStock-' + d.sectionId);
    if (!root) return;
    var active = document.activeElement;
    var focusValue = active && active.classList && active.classList.contains(INPUT) && root.contains(active) ? active.value : null;
    var fresh = d.html && typeof d.html.getElementById === 'function' ? d.html.getElementById('FtStock-' + d.sectionId) : null;
    /* the re-rendered section no longer prints the scales (e.g. the last Bangkok stock sold meanwhile): Yuva's
       new picker shows its own Weight/Size and Ship From groups again, so drop the old scales instead of doubling */
    if (!fresh && d.html && typeof d.html.querySelector === 'function' && d.html.querySelector('variant-selects')) {
      if (root.parentNode) root.parentNode.removeChild(root);
      return;
    }
    if (fresh && root.parentNode) {
      var node = document.importNode(fresh, true);
      node.setAttribute('data-ft-ready', '');
      root.parentNode.replaceChild(node, root);
      root = node;
    }
    check(root, d.variant ? d.variant.id : null);
    if (focusValue) {
      var radios = root.querySelectorAll('.' + INPUT);
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === focusValue && !radios[i].disabled) {
          try { radios[i].focus({ preventScroll: true }); } catch (_) { radios[i].focus(); }
          break;
        }
      }
    }
  }

  /* Florida priority on load: hand the server's default to Yuva once per rendered scales */
  function init() {
    var roots = document.querySelectorAll(ROOT + ':not([data-ft-ready])');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      root.setAttribute('data-ft-ready', '');
      if (attr(root, 'data-ft-sync') !== '1') continue;
      var pick = root.querySelector('.' + INPUT + ':checked');
      if (pick && !pick.disabled) handOver(root, pick, true);
    }
  }

  /* the snippet's inline script calls this when Yuva re-inserts the scales with a product swap (its
     HTMLUpdateUtility re-runs inline scripts, but this file runs only once) */
  window.ftStockInit = init;

  var subscribed = false;
  function start() {
    if (!subscribed && typeof window.subscribe === 'function') {
      window.subscribe('variantChange', onVariantChange);
      subscribed = true;
    }
    init();
  }

  /* back/forward cache: the page comes back as it was left; re-check the scales against the form */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) {
      var form = document.getElementById('product-form-' + attr(roots[i], 'data-section'));
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      if (idInput && idInput.value) check(roots[i], idInput.value);
    }
  });

  /* theme editor: a re-rendered section brings new scales */
  document.addEventListener('shopify:section:load', start);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
